<template>
  <div>
    <div class="terms-alert">
      <img
        src="static/icons/warning_gold.png"
        width="32"
        v-show="!dealerTermsPdfViewed"
      />
      <span
        v-html="$t('message.dealerTermsPleaseClick')"
        v-show="!dealerTermsPdfViewed"
        style="color: red;"
      ></span>

      <img
        src="static/icons/done_green.png"
        width="32"
        v-show="dealerTermsPdfViewed"
      />
      <i>
        <span
          v-html="$t('message.dealerTermsThanksClick')"
          v-show="dealerTermsPdfViewed"
        ></span>
      </i>
      <a
        href="#"
        target="_blank"
        @click.prevent="downloadDealerTermsPdf(pdfUrl)"
        v-show="!dealerTermsPdfViewed"
      >
        <slot></slot>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dealerTermsPdfViewed: false
    }
  },
  props: {
    pdfUrl: {
      type: String
    },
    provider: {
      type: String
    }
  },
  methods: {
    downloadDealerTermsPdf: function(url) {
      this.dealerTermsPdfViewed = true
      this.$emit('terms-downloaded')
      window.open(url)
    }
  }
}
</script>

<style lang="scss" scoped>
.terms-alert {
  display: flex;
  flex-direction: column;
}
</style>



// WEBPACK FOOTER //
// src/components/Application/LenderSelectionTermsDL.vue